module.exports = __webpack_public_path__ + "static/media/grayscale.eae14ebb.jpg";